import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';

import './PrintContainer.css';

interface PrintContainerProps {
  printButton: (handlePrint: () => void) => JSX.Element;
  children: React.ReactNode;
  isContentReady?: boolean;
  onPrintRequested?: () => void;
  documentTitle?: string;
}

function PrintContainer({
  printButton,
  children,
  isContentReady = true,
  onPrintRequested,
  documentTitle,
}: PrintContainerProps) {
  const printViewRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef: printViewRef, documentTitle });
  const [isPrintPending, setIsPrintPending] = useState(false);

  const handlePrint = () => {
    if (isContentReady) {
      reactToPrintFn();
      return;
    }

    onPrintRequested?.();
    setIsPrintPending(true);
  };

  useEffect(() => {
    if (isPrintPending && isContentReady) {
      reactToPrintFn();
      setIsPrintPending(false);
    }
  }, [isPrintPending, isContentReady, reactToPrintFn]);

  return (
    <>
      {printButton(handlePrint)}
      <div className="print-view-container">
        <div ref={printViewRef}>{children}</div>
      </div>
    </>
  );
}

export default PrintContainer;
